exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".sidebar-bottom{position:relative;padding:15px;overflow:visible;z-index:1000}.sidebar-bottom .open>.btn-default.dropdown-toggle:hover,.sidebar-bottom .open>.btn-default.dropdown-toggle:focus{background-color:transparent}.sidebar-bottom .dropup{display:inline-block;position:fixed;bottom:14px}.sidebar-bottom .dropup .dropdown-menu{text-align:center;min-width:140px;bottom:100%;position:absolute}.sidebar-bottom .profile-img{width:28px;height:28px;border-radius:50%;border:1px solid white;vertical-align:middle}.sidebar-bottom .dropdown-toggle{border:none;background:transparent;padding:0}.person-shortcut-img{height:30px;width:30px;margin-right:15px;object-fit:contain;transition:all 0.2s ease-in-out;filter:drop-shadow(0 2px 3px rgba(0,0,0,0.2));flex-shrink:0}.ques-icon{font-size:18px}.homeowner-sidebar .sidebar-wrapper>.nav.digital-mike-nav{margin-top:0px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Sidebar/style.scss
// module id = 1757
// module chunks = 32